import { Checkbox } from "@renderbus/ui";
import { useAuthManageStore } from "@/pages/authorization-management/store/auth-manage-store";
import { IAuthDetailCheckboxInfo } from "@/pages/authorization-management/components/auth-detail-table/hooks/useAuthDetailTable";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { useEffect, useState } from "react";

export function AuthDetailTableCheckbox(props: IAuthDetailCheckboxInfo) {
  const [checked, setChecked] = useState(false);
  const [isAuthObject, setIsAuthObject] = useState(false);
  const [isAuthorizationPage, setIsAuthorizationPage] = useState(
    window.location.pathname.includes("/authorization")
  );
  const { id, authority } = props;
  const {
    authObjectPermissionMap,
    setAuthObjectPermissionMap,
    allAuthObjectPermissionMap,
  } = useAuthManageStore();

  function handleCheckChange() {
    if (isAuthObject) {
      const authObjectIndex = String(id);
      if (checked) {
        setAuthObjectPermissionMap({
          ...authObjectPermissionMap,
          [authObjectIndex]: [],
        });
      } else {
        setAuthObjectPermissionMap({
          ...authObjectPermissionMap,
          [authObjectIndex]: allAuthObjectPermissionMap[authObjectIndex],
        });
      }
    } else {
      const authObjectIndex = Object.keys(allAuthObjectPermissionMap).find(
        (key) => allAuthObjectPermissionMap[key].includes(id)
      );
      if (!authObjectIndex) return;
      if (checked) {
        setAuthObjectPermissionMap({
          ...authObjectPermissionMap,
          [authObjectIndex]: authObjectPermissionMap[authObjectIndex].filter(
            (item) => item !== id
          ),
        });
      } else {
        const newData = authObjectPermissionMap[authObjectIndex]
          ? [...authObjectPermissionMap[authObjectIndex], id]
          : [id];
        setAuthObjectPermissionMap({
          ...authObjectPermissionMap,
          [authObjectIndex]: newData,
        });
      }
    }
  }

  useEffect(() => {
    const isAuthObject = Object.keys(allAuthObjectPermissionMap).includes(
      String(id)
    );
    setIsAuthObject(isAuthObject);
    if (isAuthObject) {
      const permissionIds = authObjectPermissionMap[String(id)];
      setChecked(permissionIds && permissionIds.length > 0);
    } else {
      const allPermissionIds = Object.values(authObjectPermissionMap).flat();
      setChecked(allPermissionIds.includes(id));

      setIsAuthorizationPage(
        window.location.pathname.includes("/authorization")
      );
    }
  }, [allAuthObjectPermissionMap, authObjectPermissionMap, id]);

  // fix i18next default namespace separator ':' https://www.i18next.com/overview/configuration-options
  const t = getTranslateNsT("permission", {
    nsSeparator: "#",
  });

  return (
    <Checkbox
      checked={checked}
      onChange={handleCheckChange}
      disabled={!isAuthorizationPage}
    >
      {t(`admin_${authority}`)}
    </Checkbox>
  );
}
